
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as authLldLAL6sjaJfinhufTblQ2SvXbV4tXp__siTwYISsSIMeta } from "/app/pages/auth.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as logsPYzNDkFBQEpM9Fr5cDdgb4Riuqr2sRhhbQLoGRWrsrEMeta } from "/app/pages/dashboard/logs.vue?macro=true";
import { default as poprFrQVK42qGmBcydpU7fuHJD_45XkY1eFr8zB5jlHB4HVXQMeta } from "/app/pages/dashboard/popr.vue?macro=true";
import { default as index_45F_uAQC8N4LTDgd1cq42C2ftJy11F_99xjd_45gOWaGcoMeta } from "/app/pages/dashboard/index.vue?macro=true";
import { default as plansqgX_YqEY2N4s1YSMu3UVvNR7JlgbIHJyGxZMwVMGQTIMeta } from "/app/pages/dashboard/plans.vue?macro=true";
import { default as unitsDiHIfpi2_454WK6FVhqxWwKNAUtFwVR87uOY4Bc8hnyTkMeta } from "/app/pages/dashboard/units.vue?macro=true";
import { default as usersCSZYZinANneakI2xvSMXT2_wtUwiN3LQ9hyWbISK2tYMeta } from "/app/pages/dashboard/users.vue?macro=true";
import { default as account6Aoy1jZAYBo7krW2Y6GE3uoGVOOpw9R9x435cW8uQrYMeta } from "/app/pages/dashboard/account.vue?macro=true";
import { default as datadicx4coNzo2clsRLyqoICychl_3xUCsLpAz8NCCfbb0f30Meta } from "/app/pages/dashboard/datadic.vue?macro=true";
import { default as reportsQ16gC6Aij8dzZwt3lD4_Famv4ZnO0STQkfCUwszog54Meta } from "/app/pages/dashboard/reports.vue?macro=true";
import { default as settingsdbGcSVbrN6nxlDN_45PE7jX29jsE03Vh_dTSCKrsal9FwMeta } from "/app/pages/dashboard/settings.vue?macro=true";
import { default as supportsmXI3YILCkaMuPiyC5_kIeGQEXqjCOQdgYpGjA4hmzrgMeta } from "/app/pages/dashboard/supports.vue?macro=true";
import { default as syncLogsKWwfg97DQ_8ppwWyIx1gcgmDjhaF9iEuGIqKj0Vi1H8Meta } from "/app/pages/dashboard/syncLogs.vue?macro=true";
import { default as userLogsp7MtsU95BWd3KCwP0NGrNpRYb5kaz7oJxqv6tVfiyn4Meta } from "/app/pages/dashboard/userLogs.vue?macro=true";
import { default as strategicsM8s__HdWomz_45pfXhj_fqe3xSI8EyuLhNjDxYeI9iIMAMeta } from "/app/pages/dashboard/strategics.vue?macro=true";
import { default as usergroupsatSKh2EpGFkdP5dTrhj5w80_45PV_hqOKOuPtLNb_45vDswMeta } from "/app/pages/dashboard/usergroups.vue?macro=true";
import { default as budgettypesh8rPsTniI1FkudxCdH_GVkjYhznx_45z2vHVbloJUTBmkMeta } from "/app/pages/dashboard/budgettypes.vue?macro=true";
import { default as departmentsaL9LrIAJhObZEiPcVBS9RvHaRUw6C6j57GA8BJ_45oyIgMeta } from "/app/pages/dashboard/departments.vue?macro=true";
import { default as expensetypesUCgp6pLpOLUF3QHDiVzU33n0ckbMdVyVBV2b1SeJMeEMeta } from "/app/pages/dashboard/expensetypes.vue?macro=true";
import { default as indexoIlNXz8kXaTzZvQYOndrIcvdY_45BjpL_45FOsMnW9GEqhQMeta } from "/app/pages/dashboard/projects/index.vue?macro=true";
import { default as expensesReportsWLJlZerGNYePTpdnE3IGXPonfpWBTpdLQwKv1jkPDEsMeta } from "/app/pages/dashboard/expensesReports.vue?macro=true";
import { default as create6sFxLMh2M_PHGyWmhXcL6zLJNKIPDa0LqV8_45yP9wczYMeta } from "/app/pages/dashboard/projects/create.vue?macro=true";
import { default as nationalStrategyZV4Zm7Si6byzWwwu3iwEfx9aeysY89YWqLO4_UKDKOkMeta } from "/app/pages/dashboard/nationalStrategy.vue?macro=true";
import { default as indexaOH4TKcxOUdAl_45LzGSUttpLHXcVzXz6COUS1YbFhRSAMeta } from "/app/pages/dashboard/projects/[id]/index.vue?macro=true";
import { default as projectTransferLogsK219TVByyWtBwEojkaSmfK9LYGJnH6dOqLTePbZmarEMeta } from "/app/pages/dashboard/projectTransferLogs.vue?macro=true";
import { default as checkinkX_45j6Zul02_45dgZpoDYds9_45wqukQ7RNlvnwP0ZeFVy0sMeta } from "/app/pages/dashboard/projects/[id]/checkin.vue?macro=true";
import { default as overviewdJ6c4k5vMY9BYr9LEeHk4gwKXN0JW0u9azl_45Lwvs39IMeta } from "/app/pages/dashboard/projects/[id]/overview.vue?macro=true";
import { default as budget_45statusCfSvlyunQqJmqFLDokM3jBf0qEPT0Mdli848v1LdhLEMeta } from "/app/pages/dashboard/mis-report/budget-status.vue?macro=true";
import { default as evaluationJ_GfOejghYvajjTPTudyDJIQBHoAhbhr_Br5cv_k5WsMeta } from "/app/pages/dashboard/projects/[id]/evaluation.vue?macro=true";
import { default as budget_45overview_oEfJvsEoNWsAjRhuv73JL9E8_45MvHJX2awXytCPShw0Meta } from "/app/pages/dashboard/mis-report/budget-overview.vue?macro=true";
export default [
  {
    name: "auth",
    path: "/auth",
    meta: authLldLAL6sjaJfinhufTblQ2SvXbV4tXp__siTwYISsSIMeta || {},
    component: () => import("/app/pages/auth.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "dashboard-logs",
    path: "/dashboard/logs",
    meta: logsPYzNDkFBQEpM9Fr5cDdgb4Riuqr2sRhhbQLoGRWrsrEMeta || {},
    component: () => import("/app/pages/dashboard/logs.vue")
  },
  {
    name: "dashboard-popr",
    path: "/dashboard/popr",
    meta: poprFrQVK42qGmBcydpU7fuHJD_45XkY1eFr8zB5jlHB4HVXQMeta || {},
    component: () => import("/app/pages/dashboard/popr.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: index_45F_uAQC8N4LTDgd1cq42C2ftJy11F_99xjd_45gOWaGcoMeta || {},
    component: () => import("/app/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-plans",
    path: "/dashboard/plans",
    meta: plansqgX_YqEY2N4s1YSMu3UVvNR7JlgbIHJyGxZMwVMGQTIMeta || {},
    component: () => import("/app/pages/dashboard/plans.vue")
  },
  {
    name: "dashboard-units",
    path: "/dashboard/units",
    meta: unitsDiHIfpi2_454WK6FVhqxWwKNAUtFwVR87uOY4Bc8hnyTkMeta || {},
    component: () => import("/app/pages/dashboard/units.vue")
  },
  {
    name: "dashboard-users",
    path: "/dashboard/users",
    meta: usersCSZYZinANneakI2xvSMXT2_wtUwiN3LQ9hyWbISK2tYMeta || {},
    component: () => import("/app/pages/dashboard/users.vue")
  },
  {
    name: "dashboard-account",
    path: "/dashboard/account",
    meta: account6Aoy1jZAYBo7krW2Y6GE3uoGVOOpw9R9x435cW8uQrYMeta || {},
    component: () => import("/app/pages/dashboard/account.vue")
  },
  {
    name: "dashboard-datadic",
    path: "/dashboard/datadic",
    meta: datadicx4coNzo2clsRLyqoICychl_3xUCsLpAz8NCCfbb0f30Meta || {},
    component: () => import("/app/pages/dashboard/datadic.vue")
  },
  {
    name: "dashboard-reports",
    path: "/dashboard/reports",
    meta: reportsQ16gC6Aij8dzZwt3lD4_Famv4ZnO0STQkfCUwszog54Meta || {},
    component: () => import("/app/pages/dashboard/reports.vue")
  },
  {
    name: "dashboard-settings",
    path: "/dashboard/settings",
    meta: settingsdbGcSVbrN6nxlDN_45PE7jX29jsE03Vh_dTSCKrsal9FwMeta || {},
    component: () => import("/app/pages/dashboard/settings.vue")
  },
  {
    name: "dashboard-supports",
    path: "/dashboard/supports",
    meta: supportsmXI3YILCkaMuPiyC5_kIeGQEXqjCOQdgYpGjA4hmzrgMeta || {},
    component: () => import("/app/pages/dashboard/supports.vue")
  },
  {
    name: "dashboard-syncLogs",
    path: "/dashboard/syncLogs",
    meta: syncLogsKWwfg97DQ_8ppwWyIx1gcgmDjhaF9iEuGIqKj0Vi1H8Meta || {},
    component: () => import("/app/pages/dashboard/syncLogs.vue")
  },
  {
    name: "dashboard-userLogs",
    path: "/dashboard/userLogs",
    meta: userLogsp7MtsU95BWd3KCwP0NGrNpRYb5kaz7oJxqv6tVfiyn4Meta || {},
    component: () => import("/app/pages/dashboard/userLogs.vue")
  },
  {
    name: "dashboard-strategics",
    path: "/dashboard/strategics",
    meta: strategicsM8s__HdWomz_45pfXhj_fqe3xSI8EyuLhNjDxYeI9iIMAMeta || {},
    component: () => import("/app/pages/dashboard/strategics.vue")
  },
  {
    name: "dashboard-usergroups",
    path: "/dashboard/usergroups",
    meta: usergroupsatSKh2EpGFkdP5dTrhj5w80_45PV_hqOKOuPtLNb_45vDswMeta || {},
    component: () => import("/app/pages/dashboard/usergroups.vue")
  },
  {
    name: "dashboard-budgettypes",
    path: "/dashboard/budgettypes",
    meta: budgettypesh8rPsTniI1FkudxCdH_GVkjYhznx_45z2vHVbloJUTBmkMeta || {},
    component: () => import("/app/pages/dashboard/budgettypes.vue")
  },
  {
    name: "dashboard-departments",
    path: "/dashboard/departments",
    meta: departmentsaL9LrIAJhObZEiPcVBS9RvHaRUw6C6j57GA8BJ_45oyIgMeta || {},
    component: () => import("/app/pages/dashboard/departments.vue")
  },
  {
    name: "dashboard-expensetypes",
    path: "/dashboard/expensetypes",
    meta: expensetypesUCgp6pLpOLUF3QHDiVzU33n0ckbMdVyVBV2b1SeJMeEMeta || {},
    component: () => import("/app/pages/dashboard/expensetypes.vue")
  },
  {
    name: "dashboard-projects",
    path: "/dashboard/projects",
    meta: indexoIlNXz8kXaTzZvQYOndrIcvdY_45BjpL_45FOsMnW9GEqhQMeta || {},
    component: () => import("/app/pages/dashboard/projects/index.vue")
  },
  {
    name: "dashboard-expensesReports",
    path: "/dashboard/expensesReports",
    meta: expensesReportsWLJlZerGNYePTpdnE3IGXPonfpWBTpdLQwKv1jkPDEsMeta || {},
    component: () => import("/app/pages/dashboard/expensesReports.vue")
  },
  {
    name: "dashboard-projects-create",
    path: "/dashboard/projects/create",
    meta: create6sFxLMh2M_PHGyWmhXcL6zLJNKIPDa0LqV8_45yP9wczYMeta || {},
    component: () => import("/app/pages/dashboard/projects/create.vue")
  },
  {
    name: "dashboard-nationalStrategy",
    path: "/dashboard/nationalStrategy",
    meta: nationalStrategyZV4Zm7Si6byzWwwu3iwEfx9aeysY89YWqLO4_UKDKOkMeta || {},
    component: () => import("/app/pages/dashboard/nationalStrategy.vue")
  },
  {
    name: "dashboard-projects-id",
    path: "/dashboard/projects/:id()",
    meta: indexaOH4TKcxOUdAl_45LzGSUttpLHXcVzXz6COUS1YbFhRSAMeta || {},
    component: () => import("/app/pages/dashboard/projects/[id]/index.vue")
  },
  {
    name: "dashboard-projectTransferLogs",
    path: "/dashboard/projectTransferLogs",
    meta: projectTransferLogsK219TVByyWtBwEojkaSmfK9LYGJnH6dOqLTePbZmarEMeta || {},
    component: () => import("/app/pages/dashboard/projectTransferLogs.vue")
  },
  {
    name: "dashboard-projects-id-checkin",
    path: "/dashboard/projects/:id()/checkin",
    meta: checkinkX_45j6Zul02_45dgZpoDYds9_45wqukQ7RNlvnwP0ZeFVy0sMeta || {},
    component: () => import("/app/pages/dashboard/projects/[id]/checkin.vue")
  },
  {
    name: "dashboard-projects-id-overview",
    path: "/dashboard/projects/:id()/overview",
    meta: overviewdJ6c4k5vMY9BYr9LEeHk4gwKXN0JW0u9azl_45Lwvs39IMeta || {},
    component: () => import("/app/pages/dashboard/projects/[id]/overview.vue")
  },
  {
    name: "dashboard-mis-report-budget-status",
    path: "/dashboard/mis-report/budget-status",
    meta: budget_45statusCfSvlyunQqJmqFLDokM3jBf0qEPT0Mdli848v1LdhLEMeta || {},
    component: () => import("/app/pages/dashboard/mis-report/budget-status.vue")
  },
  {
    name: "dashboard-projects-id-evaluation",
    path: "/dashboard/projects/:id()/evaluation",
    meta: evaluationJ_GfOejghYvajjTPTudyDJIQBHoAhbhr_Br5cv_k5WsMeta || {},
    component: () => import("/app/pages/dashboard/projects/[id]/evaluation.vue")
  },
  {
    name: "dashboard-mis-report-budget-overview",
    path: "/dashboard/mis-report/budget-overview",
    meta: budget_45overview_oEfJvsEoNWsAjRhuv73JL9E8_45MvHJX2awXytCPShw0Meta || {},
    component: () => import("/app/pages/dashboard/mis-report/budget-overview.vue")
  }
]